import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../_service/authentication.service';
import { GlobalEventsService } from '../_service/globalevents.service';

@Component({
    template: '',
})

export class LogoutComponent implements OnInit {
    loading = false;
    error = '';

    constructor(private authenticationService: AuthenticationService,
                private router: Router,
                private globalEventsService: GlobalEventsService) {
    }

    ngOnInit() {
        this.authenticationService.logout()
            .subscribe(
                data => {
                    this.globalEventsService.showIsLoggedIn(false);
                    this.router.navigate(['/']);
                }, error => {
                    this.globalEventsService.showIsLoggedIn(false);
                    this.router.navigate(['/']);
                });
    }

}
